(function () {
	var sections = document.querySelectorAll('.home-makes-diff');
	var ticking = false;

	if (!sections.length) {
			return;
	}

	function syncExpandedState(card) {
			var expanded = card.classList.contains('is-active') || card.classList.contains('is-touched');

			card.setAttribute('aria-expanded', expanded ? 'true' : 'false');
	}

	function setCenteredCard(section) {
			var marquee = section.querySelector('.home-makes-diff-marquee');
			var cards = section.querySelectorAll('.home-makes-diff-card');
			var marqueeRect;
			var marqueeCenter;
			var centeredCard = null;
			var closestDistance = Infinity;

			if (!marquee || !cards.length) {
					return;
			}

			marqueeRect = marquee.getBoundingClientRect();
			marqueeCenter = marqueeRect.left + (marqueeRect.width / 2);

			cards.forEach(function (card) {
					var rect = card.getBoundingClientRect();
					var cardCenter = rect.left + (rect.width / 2);
					var distance = Math.abs(marqueeCenter - cardCenter);

					if (distance < closestDistance) {
							closestDistance = distance;
							centeredCard = card;
					}
			});

			cards.forEach(function (card) {
					card.classList.toggle('is-active', card === centeredCard);
					syncExpandedState(card);
			});
	}

	function updateCenteredCards() {
			sections.forEach(setCenteredCard);
	}

	function requestCenteredCardsUpdate() {
			if (ticking) {
					return;
			}

			ticking = true;

			window.requestAnimationFrame(function () {
					updateCenteredCards();
					ticking = false;
					requestCenteredCardsUpdate();
			});
	}

	function getTranslateX(element) {
			var transform = window.getComputedStyle(element).transform;
			var match;

			if (!transform || transform === 'none') {
					return 0;
			}

			match = transform.match(/^matrix\((.+)\)$/);

			if (match) {
					return parseFloat(match[1].split(',')[4]) || 0;
			}

			match = transform.match(/^matrix3d\((.+)\)$/);

			if (match) {
					return parseFloat(match[1].split(',')[12]) || 0;
			}

			return 0;
	}

	function getTrackGap(track) {
			var gap = window.getComputedStyle(track).columnGap;

			return parseFloat(gap) || 0;
	}

	function normalizeOffset(offset, distance) {
			if (!distance) {
					return 0;
			}

			offset = offset % distance;

			if (offset > 0) {
					offset -= distance;
			}

			return offset;
	}

	function getAnimationDuration(track) {
			var duration = window.getComputedStyle(track).animationDuration.split(',')[0];
			var seconds = parseFloat(duration) || 48;

			return duration.indexOf('ms') > -1 ? seconds / 1000 : seconds;
	}

	function setTrackAnimationOffset(track, offset) {
			var distance = (track.getBoundingClientRect().width / 2) + (getTrackGap(track) / 2);
			var duration = getAnimationDuration(track);
			var progress;

			offset = normalizeOffset(offset, distance);
			progress = distance ? Math.abs(offset) / distance : 0;

			track.style.transform = '';
			track.style.animation = '';
			track.style.animationDelay = '-' + (progress * duration) + 's';
			track.style.animationPlayState = '';
	}

	function setupMarqueeDrag(section) {
			var marquee = section.querySelector('.home-makes-diff-marquee');
			var track = section.querySelector('.home-makes-diff-track');
			var drag = {
					active: false,
					dragging: false,
					pointerId: null,
					startX: 0,
					startY: 0,
					startOffset: 0
			};

			if (!marquee || !track || !window.PointerEvent) {
					return;
			}

			marquee.style.touchAction = 'pan-y';
			marquee.style.cursor = 'grab';

			function releasePointer(event) {
					if (marquee.releasePointerCapture && marquee.hasPointerCapture && marquee.hasPointerCapture(event.pointerId)) {
							marquee.releasePointerCapture(event.pointerId);
					}
			}

			marquee.addEventListener('pointerdown', function (event) {
					if (event.pointerType === 'mouse' && event.button !== 0) {
							return;
					}

					if (event.isPrimary === false) {
							return;
					}

					drag.active = true;
					drag.dragging = false;
					drag.pointerId = event.pointerId;
					drag.startX = event.clientX;
					drag.startY = event.clientY;
					drag.startOffset = getTranslateX(track);
					section.homeMakesDiffSuppressClick = false;
					track.style.animationPlayState = 'paused';
					marquee.style.cursor = 'grabbing';

					if (marquee.setPointerCapture) {
							marquee.setPointerCapture(event.pointerId);
					}
			});

			marquee.addEventListener('pointermove', function (event) {
					var deltaX;
					var deltaY;

					if (!drag.active || drag.pointerId !== event.pointerId) {
							return;
					}

					deltaX = event.clientX - drag.startX;
					deltaY = event.clientY - drag.startY;

					if (!drag.dragging) {
							if (Math.abs(deltaX) < 8) {
									return;
							}

							if (Math.abs(deltaY) > Math.abs(deltaX)) {
									drag.active = false;
									track.style.animationPlayState = '';
									marquee.style.cursor = 'grab';
									releasePointer(event);
									return;
							}

							drag.dragging = true;
							section.homeMakesDiffSuppressClick = true;
							track.style.animation = 'none';
							track.style.transform = 'translateX(' + drag.startOffset + 'px)';
					}

					event.preventDefault();
					track.style.transform = 'translateX(' + (drag.startOffset + deltaX) + 'px)';
					updateCenteredCards();
			});

			function endDrag(event) {
					var offset;

					if (!drag.active || drag.pointerId !== event.pointerId) {
							return;
					}

					offset = getTranslateX(track);

					if (drag.dragging) {
							setTrackAnimationOffset(track, offset);
							window.setTimeout(function () {
									section.homeMakesDiffSuppressClick = false;
							}, 0);
					} else {
							track.style.animationPlayState = '';
							section.homeMakesDiffSuppressClick = false;
					}

					drag.active = false;
					drag.dragging = false;
					drag.pointerId = null;
					marquee.style.cursor = 'grab';
					releasePointer(event);

					updateCenteredCards();
			}

			marquee.addEventListener('pointerup', endDrag);
			marquee.addEventListener('pointercancel', endDrag);
	}

	sections.forEach(function (section) {
			section.querySelectorAll('.home-makes-diff-card').forEach(function (card) {
					card.addEventListener('click', function (event) {
							if (section.homeMakesDiffSuppressClick) {
									event.preventDefault();
									return;
							}

							card.classList.toggle('is-touched');
							syncExpandedState(card);
					});
			});

			setupMarqueeDrag(section);
	});

	updateCenteredCards();
	requestCenteredCardsUpdate();
	window.addEventListener('resize', updateCenteredCards);
})();
